var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveform(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 143,
    height: 8,
    viewBox: "0 0 143 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 80,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 40,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 120,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 20,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 100,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 60,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 10,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 90,
    width: 3,
    height: 8,
    rx: 1.5,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 135,
    width: 3,
    height: 8,
    rx: 1.5,
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 50,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 130,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 30,
    width: 3,
    height: 8,
    rx: 1.5,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 110,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 70,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 5,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 85,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 45,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 125,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 25,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 105,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 65,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 15,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 95,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 140,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 55,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 35,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 115,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.6,
    x: 75,
    y: 2,
    width: 3,
    height: 4,
    rx: 1.5,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveform);
export default __webpack_public_path__ + "static/media/waveform.95cd9d384db3f2fce0563a8cd1d037b5.svg";
export { ForwardRef as ReactComponent };